import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Clipboard from "../../assets/icons/clipboard.svg";
import searchIcon from "../../assets/icons/search.svg";
import send from "../../assets/icons/send.svg";
import "../../assets/styles/local/TaskMain.css";
import "../../assets/styles/local/contactTaskPopup.css";
import "../../assets/styles/local/AddTaskModal.css";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import cameraicon from "../../assets/icons/camera-icon.svg";
import foldericon from "../../assets/icons/folder-icon.svg";
import Webcam from "react-webcam";
import moment from "moment";
import { FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Icon2 from "../../assets/images/Group 354.svg";
import "../../assets/styles/local/MvpNewAddTask.css";
import Modal from "react-bootstrap/Modal";
import navigationIcon from "../../assets/icons/send.png";
import clipboard from "../../assets/icons/clipboard.png";
import photoIcon from "../../assets/icons/Photo.png";
import timerIcon from "../../assets/icons/Timer.png";
import XiconCircle from "../../assets/icons/x-circle.svg";
import playButton from "../../assets/icons/Play.svg";
import checkedButton from "../../assets/icons/WhiteChecked.svg";
import checkedButton2 from "../../assets/icons/Checked.svg";
import bin from "../../assets/icons/Bin.svg";
import ReactSignatureCanvas from "react-signature-canvas";
import { TfiPencilAlt2 } from "react-icons/tfi";
import { RiEraserFill } from "react-icons/ri";
import whitePen from "../../assets/icons/whitePen.png";
import RightArrow from "../../assets/icons/Right arrow.svg";
import LeftArrow from "../../assets/icons/Right arrow.svg";
import Linkify from "react-linkify";
import { axiosInstance } from "../../redux/constants/axiosInstance";

import {
  GetTimeSession,
  ProjectDropdown,
  addCheckList,
  deleteChecklist,
  fetchProjectByCompany,
  fetchFormById,
  fetchTask,
  FetchActiveUsers,
  UpdateTaskImage,
  updateTask,
  AdddocumenttoTask,
  DeleteDocs,
  UpdateTaskDescription,
  emptyTaskState,
} from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { useLocation } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import {
  RichUtils,
  convertToRaw,
  EditorState,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import parse from "html-react-parser";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import simpleRequest from "../../utils/helpers/simpleRequest";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import {
  Checklist,
  AddForm,
  Activity,
  TaskProductsPart,
} from "../../components/Planboard";
import MvpNewTrack from "../../pages/dynamic/MvpNewTrack";
import axios from "axios";
import {
  API_URL,
  FETCH_TASK_BY_ID,
  FILES_INSERT_DOC_TO_S3,
} from "../../redux/constants/type";
import Loader from "../../components/Dailogs/Loader";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import CertificatePDF from "../../utils/ReactPDF/CertificatePDF";
import { formatDateTime } from "../../utils/timeZone/formatDateTime";

const MvpNewAddTask = (props) => {
  const signRef = useRef(null);
  const signRef2 = useRef(null);
  const { taskId } = useParams();
  const rowClickRef = useRef([]);
  const screenSize = useScreenSize();

  const userid = localStorage.getItem("userid");

  const addDocumentToTaskRes = useSelector(
    (state) => state.user.addDocumentToTaskRes,
  );

  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );

  const [fetchAddTask, setFetchAddTask] = useState({});
  const t = (key) => fetchAddTask?.[key] || "";
  const [fetchTransUpdateTaskList, setFetchTransUpdateTaskList] = useState({});
  const tt = (key) => fetchTransUpdateTaskList?.[key] || "";
  const location = useLocation();
  const taskSearchRef = useRef(null);
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const projectSearchRef = useRef(null);
  const assigneeDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const sectionDropdownRef = useRef(null);
  const priorityDropdownRef = useRef(null);
  const duplicateDropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const dependenciesRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const roleAccess = window.localStorage.getItem("roleid");
  const userlastname = window.localStorage.getItem("lastname");
  const userfirstname = window.localStorage.getItem("firstname");
  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");

  const [estimatedTime, setEstimatedTime] = useState("0");
  const [title, setTitle] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [searchPeople, setSearchPeople] = useState("");
  const [description, setDescription] = useState("");
  const [workAddress, setWorkAddress] = useState("");
  const [pinCodeForAdress, setPinCodeForAdress] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [nminutes, setNMinutes] = useState(); //Don’t
  const [notiTime, setNotiTime] = useState(); //notify
  const notificationTimes = [
    t("15 Minutes"),
    t("30 Minutes"),
    t("1 Hour"),
    t("24 Hour"),
    t("notify") + " " + t("Don't "),
  ];
  useEffect(() => {
    fetchScreenTranslations("Add-Task").then((res) => {
      setFetchAddTask(res);
      setNotiTime(res[57]?.translation ? res[57]?.translation : "notify");
      setNMinutes(res[58]?.translation ? res[58]?.translation : "Don’t");
    });
    fetchScreenTranslations("Updated-Task").then((res) => {
      setFetchTransUpdateTaskList(res);
    });
  }, []);
  const [statusId, setStatusId] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [priorityId, setPriorityId] = useState("");
  const [priorityName, setPriorityName] = useState("");
  const [statusName, setStatusName] = useState("");
  const [voucherCreated, setVoucherCreated] = useState(false);
  const [voucher, setVoucher] = useState({});
  const [showNotiDropDown, setShowNotiDropDown] = useState(false);
  const [client, setClient] = useState(null);
  const [project, setProject] = useState(null);
  const [mainProjectList, setMainProjectList] = useState([]);
  const [fullMainProjectList, setFullMainProjectList] = useState([]);
  const [company, setCompany] = useState(null);
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [showProjectDrop, setShowProjectDrop] = useState(false);
  const [showDependencyDrop, setShowDependencyDrop] = useState(false);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [showSectionDrop, setShowSectionDrop] = useState(false);
  const [showPriorityDrop, setShowPriorityDrop] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [fullProjectList, setFullProjectList] = useState([]);
  const [fullDocPeopleList2, setFullDocPeopleList2] = useState([]);
  const [dependencyList, setDependencyList] = useState([]);
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const [showAddItem, setShowAddItem] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [checklistTitle, setChecklistTitle] = useState("");
  const [totalCheck, setTotalCheck] = useState("");
  const [percent, setPercent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [choose, setChoose] = useState("");
  const [chooselast, setChooselast] = useState("");
  const [activeuser, setActiveuser] = useState([]);
  const [showDropPeopleComm, setShowDropPeopleComm] = useState(false);
  const [totalHours, setTotalHours] = useState("00");
  const [totalMinutes, setTotalMinutes] = useState("00");
  const [editDescription, setEditDescription] = useState(false);
  const textareaRef = useRef(null);
  const [signUrl, setSignUrl] = useState("");

  // Effects

  useEffect(() => {
    // Dynamically adjust the height if description has preloaded data.
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [description, editDescription]);

  const { GetTimeSessionResponse } = useSelector((state) => state.user);

  const fetchProjectsResponse = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const projectListData = useSelector(
    (state) => state.user.fetchCompanyProjectData,
  );

  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse,
  );

  const fetchTaskResponse = useSelector(
    (state) => state.user.fetchTaskResponse,
  );

  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse,
  );

  const addChecklistResponse = useSelector(
    (state) => state.user.addChecklistResponse,
  );
  const deleteChecklistResponse = useSelector(
    (state) => state.user.deleteChecklistResponse,
  );

  const fetchAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const updateTaskImageRes = useSelector(
    (state) => state.user.updateTaskImageRes,
  );

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const linkDecorator = (decoratedHref, decoratedText, key) => (
    <a
      href={decoratedHref}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "blue", textDecoration: "underline" }}
    >
      {decoratedText}
    </a>
  );

  const changeApplied = (e) => {
    setEditorState(e);
    setChangeComp("changed");
  };

  const emojiPickerRef = useRef(null);

  useEffect(() => {
    dispatch(fetchTask(taskId));
    dispatch(
      GetTimeSession(
        "00000000-0000-0000-0000-000000000000",
        taskId,
        userid,
        moment().format("DD/MM/YYYY"),
        moment().format("HH:mm:ss"),
      ),
    );
  }, [dispatch, taskId, userid]);

  useEffect(() => {
    if (GetTimeSessionResponse) {
      const totalTime = GetTimeSessionResponse?.data?.totalHoursTracked || 0;
      const [hours, minutes] = totalTime.toString().split(".");
      setTotalHours(hours?.padStart(2, "0"));
      setTotalMinutes(minutes?.padStart(2, "0"));
    }
  }, [GetTimeSessionResponse]);

  useEffect(() => {
    // Function to handle click outside
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        // Click occurred outside the emoji picker, so close it
        setShowEmojiPicker(false);
      }
      if (
        dependenciesRef.current &&
        !dependenciesRef.current.contains(event.target)
      ) {
        setShowDependencyDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectedUser = (e) => {
    let fullName = `${e?.firstname} ${e?.lastname}`;
    // let afterAt = props.val.split("@")[ 0 ];
    let afterAt = props.val.split("")[0];
    let combineValue = afterAt + fullName;
    props.setVal(combineValue);
    setShowDropPeopleComm(false);
    props.setTaggedUser([e.userid]);
  };

  useEffect(() => {
    if (projectListData?.status == true) {
      setProjectList(projectListData?.data);
      setFullProjectList(projectListData?.data);
      setChoose(projectListData?.data[0]?.contactdetails[0]?.firstname);
      setChooselast(projectListData?.data[0]?.contactdetails[0]?.lastname);

      if (props.defaultContactId) {
        const mapped = projectListData?.data.map((x) => {
          return x.contactdetails[0];
        });
        const findOne = mapped.findIndex(
          (x) => x?.contactid == props?.defaultContactId,
        );
        if (findOne >= 0) {
          let contactid = mapped?.[findOne]?.contactid;
          let contactname = `${mapped?.[findOne]?.firstname} ${mapped?.[findOne]?.lastname}`;
          setClient({ contactid, contactname });
          setCompany(mapped?.[findOne]?.contactclients[0]?.clientname);
        }
      }
    }
  }, [projectListData]);

  useEffect(() => {
    dispatch(fetchProjectByCompany(companyId));
    dispatch(FetchActiveUsers(companyId));
    dispatch(ProjectDropdown());
    dispatch(fetchTask(taskId));
  }, []);

  useEffect(() => {
    if (fetchProjectsResponse?.status === true) {
      setMainProjectList(fetchProjectsResponse?.data);
      setFullMainProjectList(fetchProjectsResponse?.data);
    }
  }, [fetchProjectsResponse]);

  const handleAddChecklist = () => {
    if (checklistTitle != "") {
      dispatch(addCheckList(userId, checklistTitle));
    }
  };

  useEffect(() => {
    if (addChecklistResponse?.status === true) {
      setChecklist([
        ...checklist,
        {
          checklistname: addChecklistResponse?.data?.checklisttitle,
          checklistid: addChecklistResponse?.data?.checklistid,
        },
      ]);
      setChecklistTitle("");
      setShowAddItem(false);
    }
  }, [addChecklistResponse]);

  useEffect(() => {
    if (checklist.length) {
      let check = checklist.filter((item) => item.ischecklist === 1);
      if (check.length) {
        let percentage = (check.length / checklist.length) * 100;
        setPercent(percentage);
      } else {
        // handle the case when there are no items with ischecklist equal to 1
        setPercent(0);
      }
    } else {
      // handle the case when the checklist is empty
      setPercent(0);
    }
  }, [checklist]);

  React.useEffect(() => {
    if (deleteChecklistResponse?.status === true) {
      let data = [...checklist];
      data = data.filter(
        (item) => item.checklistid !== deleteChecklistResponse?.data,
      );
      setChecklist(data);
      setTotalCheck(data.length);
    }
  }, [deleteChecklistResponse]);

  const [showMoreComm, setShowMoreComm] = useState(false);
  let displayQuantity = showMoreComm ? 100 : 1;

  useEffect(() => {
    if (fetchTaskResponse?.status === true) {
      setShowLoader(false);
      setSignUrl(fetchTaskResponse?.data?.[0]?.singnature);
      setShowClientDrop(false);
      setShowProjectDrop(false);
      setSelectedEquipments([]);
      // setWorkProofImgLink(fetchTaskResponse?.data[0].image);
      setWorkProofImgLink(
        fetchTaskResponse?.data[0]?.document?.filter((x) => x?.isStarted === 1)
          ?.length
          ? fetchTaskResponse.data[0].document
              .filter((x) => x?.isStarted === 1)
              .sort((a, b) => new Date(a.createdat) - new Date(b.createdat)) // optional: agar tumhe order chahiye
              .map((x) => x.url)
          : [],
      );
      setWorkProofImgLink2(
        fetchTaskResponse?.data[0]?.document?.filter((x) => x?.isStarted === 2)
          ?.length
          ? fetchTaskResponse.data[0].document
              .filter((x) => x?.isStarted === 2)
              .sort((a, b) => new Date(a.createdat) - new Date(b.createdat)) // optional: agar tumhe order chahiye
              .map((x) => x.url)
          : [],
      );

      // setSignatureData(
      //   fetchTaskResponse?.data[0]?.document.filter(
      //     (x) => x?.isClientSignature === 1 || x?.isClientSignature === 2
      //   ) || []
      // );

      const clientSignURL = fetchTaskResponse?.data[0]?.document.find(
        (x) => x?.isClientSignature === 1,
      );
      setClientSignature(clientSignURL?.url || "");
      setClientSignatureID(clientSignURL?.documentId || "");

      const executantSignURL = fetchTaskResponse?.data[0]?.document.find(
        (x) => x?.isClientSignature === 2,
      );
      setExecutantSignature(executantSignURL?.url || "");
      setExecutantSignatureID(executantSignURL?.documentId || "");

      setProofOfWorkData(
        fetchTaskResponse?.data[0]?.document.filter(
          (x) => x?.isStarted === 1 || x?.isStarted === 2,
        ) || [],
      );

      setChecklist(fetchTaskResponse?.data[0].checklist);
      setDependencyList(fetchTaskResponse?.data[0].dependencies);
      setPriorityId(fetchTaskResponse?.data[0].priorityid);
      setStatusId(fetchTaskResponse?.data[0].statusid);
      setSectionId(fetchTaskResponse?.data[0].sectionid);

      let time2 = `${fetchTaskResponse?.data[0].startingDate}.000Z`;
      setStartDate(new Date(time2));

      setEndDate(new Date(fetchTaskResponse?.data[0].endDate));

      if (fetchTaskResponse?.data[0].endDate) {
        let time = `${fetchTaskResponse?.data[0].endDate}.000Z`;
        setDueDate(new Date(time));
        setHours(
          fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[0] !==
            "00"
            ? fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[0]
            : "",
        );
        setMinutes(
          fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[1] !==
            "00"
            ? fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[1]
            : "",
        );
      } else {
        setDueDate(new Date());
      }
      setEquipmentDetails(fetchTaskResponse?.data[0].equipmentdetails);
      setAssigneeMain(
        fetchTaskResponse?.data[0].assignee.map((x) => ({
          assigneeid: x.assigneeid,
          type: "user",
        })),
      );
      // setDescription(
      //   localStorage.getItem("formName")
      //     ? localStorage.getItem("formName")
      //     : fetchTaskResponse?.data[0].taskdescription
      // );
      // setDescription(fetchTaskResponse?.data[0].taskdescription);
      const blocksFromHtml = htmlToDraft(
        fetchTaskResponse?.data[0].taskdescription,
      );
      const contentState = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
      );
      const descEditorState = EditorState.createWithContent(contentState);

      setEditorState2(descEditorState);

      setWorkAddress(fetchTaskResponse?.data[0]?.workaddress ?? "");
      setTitle(fetchTaskResponse?.data[0].taskname);
      setClient(fetchTaskResponse?.data[0].contact[0]);
      setCompany(
        fetchTaskResponse?.data[0].contact[0]?.clientdetails[0]?.clientname,
      );
      setEstimatedTime(fetchTaskResponse?.data[0].estimatedTime);
      const project1 = {
        projectid: fetchTaskResponse?.data[0]?.project[0]?.projectid,
        projectname: fetchTaskResponse?.data[0]?.project[0]?.projectname,
        projectcode: fetchTaskResponse?.data[0]?.project[0]?.projectcode,
        clientname: fetchTaskResponse?.data[0]?.project[0]?.clientname,
      };

      setProject(project1);
      const total = [...fetchTaskResponse?.data[0].checklist];
      setTotalCheck(total.length);
      setStatusName(fetchTaskResponse?.data[0].statusName);
      const statusid = fetchTaskResponse?.data[0].statusid;
      const priorityid = fetchTaskResponse?.data[0].priorityid;
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_EXTREME) {
        setPriorityName("Extreme");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_HIGH) {
        setPriorityName("High");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_LOW) {
        setPriorityName("Low");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_NORMAL) {
        setPriorityName("Medium");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_TODO) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_PROGRESS) {
        setStatusName("Progress");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_COMPLETE) {
        setStatusName("Complete");
      }
      if (statusid === process.env.REACT_APP_PROJECT_SALES_PIPELINE) {
        setStatusName("Cancelled");
      }
      if (statusid === process.env.REACT_APP_PROJECT_INFO_REQUEST) {
        setStatusName("Initiated");
      }
      if (statusid === process.env.REACT_APP_PROJECT_QUOTE_REQUEST) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_PROJECT_QUOTED) {
        setStatusName("Progress");
      }
      if (statusid === "08dab011-a6cf-4069-887e-83e5f3473108") {
        setStatusName("Complete");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_TODO) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_PROGRESS) {
        setStatusName("Progress");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_COMPLETE) {
        setStatusName("Complete");
      }
      setSectionName(fetchTaskResponse?.data[0].sectionName);
      // dispatch({
      //   type: FETCH_TASK_BY_ID,
      //   data: {},
      // });
      dispatch(emptyTaskState());
    }
  }, [fetchTaskResponse, "addDocumentToTaskRes"]);

  const [assigneeMain, setAssigneeMain] = useState([]);
  const [equipmentDetails, setEquipmentDetails] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");

  function dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }

  function dataURItoBlob2(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }

  const getSignature = async (signatureBlob) => {
    let sign = "";
    if (signatureBlob?.size >= 980) {
      const formData = new FormData();

      const randomName = `signature_${crypto.randomUUID()}.png`;
      const randomName2 = `signature_${Date.now()}.png`;

      formData.append("file", signatureBlob, randomName2);

      try {
        const resp = await axiosInstance.put(
          `${API_URL}/api/Files/UploadToS3`,
          formData,
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "multipart/form-data",
            },
          },
        );
        sign = resp?.data?.[0];

        // Dispatch immediately after successful upload
        if (sign) {
          const payload = [
            {
              documentname: "signature1.png",
              link: sign,
              isClientSignature: 1,
            },
          ];
          dispatch(AdddocumenttoTask(taskId, payload));
        }
      } catch (error) {
        console.log(error);
      }
    } else sign = "";
    return sign || signUrl;
  };

  const getSignature2 = async (signatureBlob2) => {
    let sign = "";
    if (signatureBlob2?.size >= 980) {
      const formData = new FormData();

      const randomName = `signature_${crypto.randomUUID()}.png`;
      const randomName2 = `signature_${Date.now()}.png`;

      formData.append("file", signatureBlob2, randomName2);

      try {
        const resp = await axiosInstance.put(
          `${API_URL}/api/Files/UploadToS3`,
          formData,
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "multipart/form-data",
            },
          },
        );
        sign = resp?.data?.[0];

        // Dispatch immediately after successful upload
        if (sign) {
          const payload = [
            {
              documentname: "signature2.png",
              link: sign,
              isClientSignature: 2,
            },
          ];
          dispatch(AdddocumenttoTask(taskId, payload));
        }
      } catch (error) {
        console.log(error);
      }
    } else sign = "";
    return sign || signUrl;
  };

  const handleFunction = async () => {
    // const signatureBlob =
    //   signRef.current && dataURItoBlob(signRef.current.toDataURL("image/png"));
    // let signature = await getSignature(signatureBlob);

    // const signatureBlob2 =
    //   signRef2.current &&
    //   dataURItoBlob2(signRef2.current.toDataURL("image/png"));
    // let signature2 = await getSignature2(signatureBlob2);

    let signature = "";
    if (hasClientSignature) {
      const signatureBlob =
        signRef.current &&
        dataURItoBlob(signRef.current.toDataURL("image/png"));
      signature = await getSignature(signatureBlob);
    }

    if (hasExecutantSignature) {
      const signatureBlob2 =
        signRef2.current &&
        dataURItoBlob2(signRef2.current.toDataURL("image/png"));
      await getSignature2(signatureBlob2);
    }

    let year = dueDate?.toISOString().split("-")[0];
    const date = dueDate?.getDate();
    let month = dueDate?.toISOString().split("-")[1];
    let datetime;
    if (hours.length <= 2 && minutes.length <= 2) {
      if (year == undefined && month == undefined && date == undefined) {
        datetime = null;
      } else {
        datetime = `${year}-${month}-${date}T${hours.padStart(
          2,
          "0",
        )}:${minutes.padStart(2, "0")}:00.000Z`;
      }
    } else {
      if (year == undefined && month == undefined && date == undefined) {
        datetime = null;
      } else {
        datetime = `${year}-${month}-${date}T00:00:00.000Z`;
      }
    }

    dispatch(
      updateTask(
        userId,
        props.taskid,
        title,
        // description,
        draftToHtml(convertToRaw(editorState2.getCurrentContent())),
        workProofImgLink,
        statusId,
        priorityId,
        datetime,
        nminutes,
        notiTime,
        client?.contactid,
        project?.projectid ? project.projectid : null,
        dependencyList,
        checklist,
        assigneeMain,
        estimatedTime,
        // workAddress, old address without zip code.
        addressWithPincode,
        equipmentDetails,
        sectionId || "00000000-0000-0000-0000-000000000000",
        startDate,
        datetime,
        signature,
      ),
    );
  };

  useEffect(() => {
    if (updateTaskResponse?.status === true) {
      history.push("/my-task");
    }
  }, [updateTaskResponse]);

  const updateChecklist = async (checklistid, ischecklist) => {
    await simpleRequest("/api/User/UpdateChecklist", "post", {
      checklistid,
      ischecklist,
    });
  };

  const handleCheckboxChange = async (event) => {
    const status = event.target.checked; // Get the checkbox status
    if (status) {
      await ChangeStatus(process.env.REACT_APP_TASK_STATUS_COMPLETE);
    } else {
      await ChangeStatus(process.env.REACT_APP_TASK_STATUS_PROGRESS);
    }
  };

  // const ChangeStatus = async (statusid) => {
  //   await simpleRequest("/api/User/ChangeStatus", "post", {
  //     taskId,
  //     statusid, // Pass the checkbox status
  //   });
  // };

  const ChangeStatus = async (statusid) => {
    const res = await simpleRequest("/api/User/ChangeStatus", "post", {
      taskId,
      statusid,
      jwtToken: localStorage.getItem("token"),
    });

    if (res?.status === true) {
      setRunFunctionFromParent(true);
      setTimeout(() => {
        // history.goBack();
        history.push("/my-task");
      }, 20000);
    } else {
      console.log("Status change failed", res);
    }

    // optional: agar aage use karna ho to return bhi kar do
    return res;
  };

  useEffect(() => {
    if (filesInsertDocToS3Res[0]?.status === true) {
      dispatch({
        type: FILES_INSERT_DOC_TO_S3,
        data: {},
      });
      setTimeout(() => {
        history.push("/my-task");
      }, 500);
    }
  }, [filesInsertDocToS3Res]);

  React.useEffect(() => {
    if (clientSearch) {
      let list = [...fullProjectList];
      list = list.filter((client) => {
        const firstName =
          client.contactdetails?.[0]?.firstname?.toLowerCase() || "";
        const lastName =
          client.contactdetails?.[0]?.lastname?.toLowerCase() || "";
        const clientName =
          client.contactdetails?.[0]?.contactclients?.[0]?.clientname?.toLowerCase() ||
          "";
        const fullName = `${firstName} ${lastName}`;

        return (
          firstName.startsWith(clientSearch.toLowerCase()) ||
          lastName.startsWith(clientSearch.toLowerCase()) ||
          clientName.includes(clientSearch.toLowerCase()) ||
          fullName.startsWith(clientSearch.toLowerCase())
        );
      });
      setProjectList(list);
    } else {
      setProjectList([...fullProjectList]);
    }
  }, [clientSearch]);

  React.useEffect(() => {
    if (projectSearch) {
      let list = [...fullMainProjectList];
      list = list.filter((project) => {
        const fullName = `${project.projectname} - ${project.clientname}`;
        return (
          project.projectname
            ?.toLowerCase()
            .includes(projectSearch?.toLowerCase()) ||
          project.projectname
            ?.toLowerCase()
            .startsWith(projectSearch?.toLowerCase()) ||
          project.projectcode
            ?.toLowerCase()
            .startsWith(projectSearch?.toLowerCase()) ||
          project.clientname
            ?.toLowerCase()
            .startsWith(projectSearch?.toLowerCase()) ||
          fullName?.toLowerCase().startsWith(projectSearch?.toLowerCase())
        );
      });
      setMainProjectList(list);
    } else {
      setMainProjectList([...fullMainProjectList]);
    }
  }, [projectSearch]);

  useEffect(() => {
    if (activeStatusResponse?.status === true) {
      setFullDocPeopleList2(activeStatusResponse?.data);
      setActiveuser(activeStatusResponse?.data);
      // setAbbrevation(activeStatusResponse?.data[0]?.firstname);
      // setAbbrevationlast(activeStatusResponse?.data[0]?.lastname);
    }
  }, [activeStatusResponse]);

  React.useEffect(() => {
    if (searchPeople) {
      let people = [...fullDocPeopleList2];
      people = people.filter((people) => {
        const fullName = `${people.firstname} ${people.lastname}`;
        return (
          people.firstname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          people.lastname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
        );
      });

      setActiveuser(people);
    } else {
      setActiveuser([...fullDocPeopleList2]);
    }
  }, [searchPeople]);

  const [change, setChange] = useState("");
  const [changeComp, setChangeComp] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const extension =
    attachmentUrl && attachmentUrl.split(".").pop().toLowerCase();
  const [workProofImgLink, setWorkProofImgLink] = useState([]);
  const [workProofImgLink2, setWorkProofImgLink2] = useState([]);
  const [openCameraPopup, setOpenCameraPopup] = useState(false);
  const isImage = ["jpg", "jpeg", "png", "webp", "gif"].includes(extension);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      taskSearchRef.current &&
      !taskSearchRef.current.contains(event.target)
    ) {
      setShowClientDrop(false);
    }
    if (
      projectSearchRef.current &&
      !projectSearchRef.current.contains(event.target)
    ) {
      setShowProjectDrop(false);
    }
    if (
      assigneeDropdownRef.current &&
      !assigneeDropdownRef.current.contains(event.target)
    ) {
      setShowDropPeople(false);
      setSearchPeople("");
    }
    if (
      statusDropdownRef.current &&
      !statusDropdownRef.current.contains(event.target)
    ) {
      setShowStatusDrop(false);
    }
    if (
      sectionDropdownRef.current &&
      !sectionDropdownRef.current.contains(event.target)
    ) {
      setShowSectionDrop(false);
    }
    if (
      priorityDropdownRef.current &&
      !priorityDropdownRef.current.contains(event.target)
    ) {
      setShowPriorityDrop(false);
    }

    if (
      notificationDropdownRef.current &&
      !notificationDropdownRef.current.contains(event.target)
    ) {
      setShowNotiDropDown(false);
    }
  };

  useEffect(() => {
    const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
    const textMessage = convertToRaw(newState.getCurrentContent());
    props.setVal(JSON.stringify(textMessage));
  }, [editorState]);

  const isJson = (item) => {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
      value = JSON.parse(value);
    } catch (e) {
      return false;
    }

    return typeof value === "object" && value !== null;
  };

  const getFormattedMessage = (message) => {
    let htmlMessage = "";
    let converFrom = convertFromRaw(JSON.parse(message));
    let convertedHtml = draftToHtml(convertToRaw(converFrom));
    if (convertedHtml != "<p><br></p>") {
      htmlMessage = convertedHtml;
    }
    return htmlMessage;
  };

  // postal Code start
  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            setPinCodeForAdress(postalCode);
          }
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };
  // const addressWithPincode = `${deliveryAddress}, ${pinCodeForAdress}`;
  const addressWithPincode = `${workAddress}${
    pinCodeForAdress ? ", " + pinCodeForAdress : ""
  }`;
  // postal Code end

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => {
    history.goBack();
  };

  const handleNavigate = () => {
    //history.push(`/tasks/${taskId}/location`);
  };

  const handleTrackTask = () => {
    history.push(`/task-track/${taskId}`);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Get the current day of the week
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const today = new Date();
  const dayName = daysOfWeek[today.getDay()];

  // for signature
  const [quote, setQuote] = useState(null);
  const [hasClientSignature, setHasClientSignature] = useState(false);
  const [hasExecutantSignature, setHasExecutantSignature] = useState(false);

  const handleUseEraser = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "destination-out";
    context.strokeStyle = "rgba(239, 239, 239, 1)";
    context.lineWidth = 15;
  };

  const handleDraw = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "source-over";
    context.lineWidth = 15;
  };

  const clearCanvas = () => {
    signRef.current?.clear();
    setHasClientSignature(false);
    setClientSignature("");
    setSignUrl("");
    dispatch(DeleteDocs(clientSignatureID));
  };

  const clearCanvas2 = () => {
    signRef2.current?.clear();
    setHasExecutantSignature(false);
    setExecutantSignature("");
    setSignUrl("");
    dispatch(DeleteDocs(executantSignatureID));
  };

  const onSignEnd = () => {
    setHasClientSignature(true);
  };

  const onSignEnd2 = () => {
    setHasExecutantSignature(true);
  };

  const [dataFromChild, setDataFromChild] = useState();

  // Callback function to receive data from child
  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };

  // asc camera open start.
  const [cameraOpen, setCameraOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  const videoConstraints = {
    width: 500,
    height: 720,
    facingMode: "user",
  };

  const AscWeb = ({ onImageUpload }) => {
    return (
      <Webcam
        audio={false}
        width={"100%"}
        height={"100%"}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
      >
        {({ getScreenshot }) => (
          <div className="d-flex justify-content-center gap-3 py-4">
            <button
              className="cameraButton"
              onClick={() => {
                setCameraOpen(false);
              }}
            >
              Cancel
            </button>

            <button
              className="cameraButton"
              onClick={() => {
                const imageSrc = getScreenshot();
                if (imageSrc) {
                  setCapturedImage(imageSrc);
                  setCameraOpen(false);
                  profileUpload(imageSrc);
                }
              }}
            >
              Capture photo
            </button>
          </div>
        )}
      </Webcam>
    );
  };

  const profileUpload = async (imageSrc) => {
    // Convert captured Image to Blob start.
    const byteString = atob(imageSrc.split(",")[1]);
    const mimeString = imageSrc.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ua = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ua[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    const file = new File([blob], `capturedImage_${Date.now()}.jpg`);
    // Convert captured Image to Blob end.

    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": " multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);

      // beginningTab
      //   ? setWorkProofImgLink(response.data[0])
      //   : setWorkProofImgLink2(response.data[0]);

      beginningTab
        ? setWorkProofImgLink((prev) => [...prev, response.data[0]])
        : setWorkProofImgLink2((prev) => [...prev, response.data[0]]);

      let payload = [response.data[0]].map((url) => ({
        // documentname: url.split("/").pop(),
        documentname: beginningTab
          ? "capturedImage1_" + Date.now()
          : "capturedImage2_" + Date.now(),
        link: url,
        isStarted: beginningTab ? 1 : 2,
      }));
      dispatch(AdddocumenttoTask(taskId, payload));
    } catch (error) {}
  };
  // asc camera open end.

  // const profileUpload = async (file) => {
  //   var formData = new FormData();
  //   formData.append("", file);
  //   try {
  //     const response = await axios.put(
  //       `${API_URL}/api/Files/UploadToS3`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": " multipart/form-data",
  //         },
  //       }
  //     );
  //     setImageUrl(response.data[0]);
  //   } catch (error) {}
  // };

  useEffect(() => {
    if (imageUrl || workProofImgLink || workProofImgLink2) {
      setOpenCameraPopup(false);
    }
  }, [imageUrl, workProofImgLink, workProofImgLink2]);

  const [beginningTab, setBeginningTab] = useState(true);
  const [proofOfWorkData, setProofOfWorkData] = useState([]);
  const [signatureData, setSignatureData] = useState([]);
  const [clientSignature, setClientSignature] = useState("");
  const [clientSignatureID, setClientSignatureID] = useState("");
  const [executantSignature, setExecutantSignature] = useState("");
  const [executantSignatureID, setExecutantSignatureID] = useState("");

  const [multiDocs, setMultiDocs] = useState([]);
  console.log("asc23", proofOfWorkData);

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < workProofImgLink.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const [currentIndex2, setCurrentIndex2] = useState(0);
  const handleNext2 = () => {
    if (currentIndex2 < workProofImgLink2.length - 1) {
      setCurrentIndex2(currentIndex2 + 1);
    }
  };

  const handlePrev2 = () => {
    if (currentIndex2 > 0) {
      setCurrentIndex2(currentIndex2 - 1);
    }
  };
  console.log("asc233", workProofImgLink);

  const [runFunctionFromParent, setRunFunctionFromParent] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);

  const [editorState2, setEditorState2] = useState(() =>
    EditorState.createEmpty(),
  );

  const changeApplied2 = (e) => {
    setEditorState2(e);
    setChangeComp("changed");
  };

  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [fetchTaskResponse]);

  const editorRef = useRef(null);
  useEffect(() => {
    if (editDescription) {
      editorRef.current?.focusEditor();
    }
  }, [editDescription]);

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {cameraOpen ? (
            <AscWeb />
          ) : (
            <div
              style={{
                pointerEvents:
                  roleAccess === process.env.REACT_APP_IS_VIEWER && "none",
              }}
            >
              <div
                className="mvp-new-track"
                style={{
                  background: "white",
                  width: "100%",
                  overflowX: "hidden",
                }}
              >
                <div>
                  <div>
                    <div>
                      <div>
                        {props.modalFunction !== "add" &&
                          !props.isBasicMember && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                              }}
                            ></div>
                          )}
                        <div
                          className="frcb"
                          // style={{ padding: "15px 2rem 0 2rem" }}
                        >
                          <div className="frc">
                            <img
                              className="task-icon-pop ms-2"
                              src={Clipboard}
                              alt=""
                              style={{ display: "inline-block" }}
                            />
                            <p className="margin-0-pop task-modal-task-text-pop ms-2">
                              {/* {fetchAddTask[0]?.translation} */}
                              {"Task Details"}
                            </p>
                          </div>
                          <div class="toggle-container d-none">
                            <label for="toggle">Complete?</label>
                            <label class="toggle-switch-task">
                              <input
                                type="checkbox"
                                id="toggle"
                                // value={
                                //     statusName === "Complete"
                                //         ? true
                                //         : false
                                // } // Dynamically set value
                                // checked={
                                //     statusName === "Complete"
                                // } // Synchronize with initial state
                                onChange={handleCheckboxChange}
                              />
                              <span class="slider"></span>
                            </label>
                          </div>
                          <div
                            className="pointer"
                            onClick={() => {
                              handleCancel();
                            }}
                          >
                            <img src={XiconCircle} alt="" />
                          </div>
                        </div>
                        <div
                          className="fc"
                          style={{
                            rowGap: "8px",
                            marginTop: "16px",
                            padding: "0 12px",
                          }}
                        >
                          <div className="task-title">{title}</div>

                          {fetchAppSideNavOptions &&
                            Array.isArray(fetchAppSideNavOptions) &&
                            fetchAppSideNavOptions.every(
                              (item) => item.packageName !== "Basic",
                            ) && (
                              <div
                                className="task-modal-new-main-box"
                                ref={projectSearchRef}
                              >
                                <div className="frcb" style={{ width: "76%" }}>
                                  <p
                                    style={{
                                      color: project?.projectname
                                        ? "#333333"
                                        : "#a5a5a5",
                                      paddingLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    className="mb-0"
                                    onClick={() => setShowProjectDrop(true)}
                                  >
                                    {project?.projectname
                                      ? `${project?.projectcode} ┃ ${project?.projectname}`
                                      : "Choose a Project"}
                                  </p>
                                </div>
                                {showProjectDrop && (
                                  <div>
                                    <div
                                      className="client-drop"
                                      style={{
                                        top: 0,
                                        left: "16%",
                                        width: "84%",
                                      }}
                                    >
                                      <p
                                        className="mb-2"
                                        style={{
                                          opacity: "60%",
                                        }}
                                      >
                                        Choose a Project
                                      </p>
                                      <div
                                        className="task-modal-new-popup-search"
                                        style={{
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <img
                                          alt=""
                                          className="mb-1 search_pop ms-2"
                                          src={searchIcon}
                                        />
                                        <input
                                          type="text"
                                          value={projectSearch}
                                          style={{
                                            margin: "0 0 0 0.5rem",
                                            fontSie: "14px",
                                            fontWeight: projectSearch
                                              ? "400"
                                              : "300",
                                            color: projectSearch
                                              ? ""
                                              : "#D5D5D5",
                                          }}
                                          placeholder="Search"
                                          className="search-style select-client-div"
                                          onChange={(e) => {
                                            setChangeComp(e.target.value);
                                            setProjectSearch(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="my-custom-scrollbar">
                                        {mainProjectList?.map(
                                          (project, index) => {
                                            return (
                                              <p
                                                className="mb-1"
                                                key={`${index}-${project.projectid}`}
                                                style={{
                                                  textTransform: "capitalize",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  setProject({
                                                    projectid:
                                                      project.projectid,
                                                    projectname:
                                                      project.projectname,
                                                    projectcode:
                                                      project.projectcode,
                                                    clientname:
                                                      project.clientname,
                                                  });
                                                  setWorkAddress(
                                                    project.deliveryaddress,
                                                  );
                                                  setShowProjectDrop(false);
                                                  setChangeComp(project);
                                                }}
                                              >
                                                {project
                                                  ? project.clientname
                                                    ? `${project?.projectname} - ${
                                                        location.pathname !==
                                                          "/addProject" &&
                                                        // location.pathname !==
                                                        //   "/updateProject" &&
                                                        !location.pathname.startsWith(
                                                          "/project/",
                                                        ) &&
                                                        project?.clientname
                                                      }`
                                                    : `${project.projectcode} ┃ ${project.projectname}`
                                                  : `${project.projectname}`}
                                              </p>
                                            );
                                          },
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                          <div
                            className="task-modal-new-main-box"
                            ref={taskSearchRef}
                          >
                            <div className="frcb" style={{ width: "76%" }}>
                              <p
                                style={{
                                  color: client?.contactname
                                    ? "#333333"
                                    : "#a5a5a5",
                                  paddingLeft: "10px",
                                  cursor: "pointer",
                                }}
                                className="mb-0"
                                onClick={() =>
                                  setShowClientDrop(!showClientDrop)
                                }
                                onChange={(e) => {
                                  setChangeComp(e.target.value);
                                }}
                              >
                                {client?.contactname ||
                                  `${t("Choose a client")}`}
                                {company ? (
                                  <span
                                    style={{
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {" "}
                                    | {company}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                            {showClientDrop && (
                              <div
                                className="client-drop"
                                style={{
                                  top: 0,
                                  left: "16%",
                                  width: "84%",
                                }}
                              >
                                <p className="mb-2">Choose a client</p>
                                <div
                                  className="client-search-main"
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                >
                                  <img
                                    alt=""
                                    className="mb-1 search_pop ms-2"
                                    src={searchIcon}
                                  />
                                  <input
                                    type="text"
                                    value={clientSearch}
                                    style={{
                                      margin: "0 0 0 0.5rem",
                                      fontSie: "14px",
                                      fontWeight: clientSearch ? "400" : "300",
                                      color: clientSearch ? "" : "#D5D5D5",
                                    }}
                                    placeholder="Search"
                                    className="search-style select-client-div"
                                    onChange={(e) => {
                                      setChangeComp(e.target.value);
                                      setClientSearch(e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="my-custom-scrollbar">
                                  {projectList?.map((project, index) => {
                                    return (
                                      <p
                                        className="mb-1 my-custom-para"
                                        key={`index-${project?.contactdetails?.[0]?.contactid}-${index}`}
                                        style={{
                                          textTransform: "capitalize",
                                          backgroundColor:
                                            client?.contactname ===
                                            `${project.contactdetails?.[0]?.firstname} ${project.contactdetails?.[0]?.lastname}`
                                              ? "#F4F5F4"
                                              : "transparent",
                                        }}
                                        onClick={() => {
                                          let contactid =
                                            project?.contactdetails?.[0]
                                              ?.contactid;
                                          let contactname = `${project?.contactdetails?.[0]?.firstname} ${project?.contactdetails?.[0]?.lastname}`;
                                          setClient({
                                            contactid,
                                            contactname,
                                          });
                                          setCompany(
                                            project?.contactdetails[0]
                                              ?.contactclients[0]?.clientname,
                                          );
                                          setShowClientDrop(false);
                                          setChangeComp(project);
                                        }}
                                      >
                                        {`${project?.contactdetails?.[0]?.firstname} ${project?.contactdetails?.[0]?.lastname}`}
                                        {project?.contactdetails?.[0]
                                          ?.contactclients?.[0]?.clientname
                                          ? ` ┃ ${project.contactdetails[0].contactclients[0].clientname}`
                                          : ""}
                                      </p>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>

                          {/* <span className="task-work-address">Work Address</span> */}

                          {!props?.isBasicMember && (
                            <div
                              className="task-modal-new-main-box"
                              style={{ minHeight: "70px" }}
                            >
                              <div
                                className="task-modal-new-address-box"
                                id="task-modal-new-address-box"
                              >
                                <GooglePlacesAutocomplete
                                  debounce={800}
                                  renderInput={(props) => (
                                    <textarea
                                      style={{
                                        border: "none",
                                        width: "100%",
                                        height: "50px",

                                        overflow: "hidden",
                                      }}
                                      {...props}
                                      rows={4}
                                      placeholder="Type a Work Address"
                                    />
                                  )}
                                  onSelect={(e) => {
                                    // handleAddressSelect(e);
                                    setWorkAddress(e.description);
                                    setChangeComp(e.description);
                                    handleAddressSelect(e);
                                  }}
                                  placeholder="Type a Work Address"
                                  // initialValue={workAddress}
                                  initialValue={addressWithPincode}
                                  withSessionToken={true}
                                />
                              </div>
                            </div>
                          )}

                          <span className="task-description">
                            Task Description
                          </span>

                          <div
                            className="task-modal-description-main-box"
                            id="addTaskComntBox2"
                          >
                            <div className="task-modal-new-address-box"></div>
                            {editDescription ? (
                              <>
                                <textarea
                                  name="description"
                                  ref={textareaRef}
                                  className="task-modal-description-textarea d-none"
                                  placeholder={t("Type a description")}
                                  value={description}
                                  onChange={(e) => {
                                    setDescription(e.target.value);
                                    setChangeComp(e.target.value);
                                  }}
                                  onClick={() => {
                                    if (
                                      description ===
                                      localStorage.getItem("formName")
                                    ) {
                                      history.push({
                                        pathname: "/form-builder",
                                        state: {
                                          formPopUp: false,
                                        },
                                      });
                                      localStorage.setItem(
                                        "formCondition",
                                        false,
                                      );
                                      const formId =
                                        localStorage.getItem("formId");
                                      dispatch(fetchFormById(formId));
                                    }
                                  }}
                                  disabled={
                                    roleAccess ===
                                    process.env.REACT_APP_IS_VIEWER
                                  }
                                  style={{
                                    cursor:
                                      roleAccess ===
                                      process.env.REACT_APP_IS_VIEWER
                                        ? "default"
                                        : description ===
                                            localStorage.getItem("formName") &&
                                          "pointer",
                                    // color: "blue",
                                  }}
                                />

                                <Editor
                                  name="description"
                                  ref={editorRef}
                                  placeholder={t("Type a description")}
                                  // value={description}
                                  editorState={editorState2}
                                  onEditorStateChange={changeApplied2}
                                  wrapperClassName="wrapper-class ms-"
                                  editorClassName="task-comment-text-pop2 text-black"
                                  toolbarClassName="toolbar-bottom-absolute"
                                  toolbarHidden={true}
                                  mention={{
                                    separator: " ",
                                    trigger: "@",
                                    suggestions: activeuser.map((x) => ({
                                      text: `${x.firstname} ${x.lastname}`,
                                      value: `${x.firstname} ${x.lastname}`,
                                      url: x.userid,
                                    })),
                                  }}
                                />
                              </>
                            ) : (
                              <div
                                className="p-3"
                                style={{
                                  whiteSpace: "pre-wrap", // Preserve newlines
                                  wordWrap: "break-word", // Handle long words gracefully
                                  color: "black", // Plain text color
                                  fontSize: "14px",
                                  wordBreak: "break-word",
                                }}
                                onClick={() => {
                                  setEditDescription(true);
                                  setEditorState2(
                                    EditorState.moveFocusToEnd(editorState2),
                                  );
                                }}
                              >
                                {/* <Linkify>{description}</Linkify> */}
                                <Linkify componentDecorator={linkDecorator}>
                                  {/* {description} */}
                                </Linkify>

                                <Linkify componentDecorator={linkDecorator}>
                                  {parse(
                                    draftToHtml(
                                      convertToRaw(
                                        editorState2.getCurrentContent(),
                                      ),
                                    ),
                                  )}
                                </Linkify>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="d-flex gap-2 pt-2 pe-3">
                          <button
                            className="ms-auto descButton invisible"
                            style={{ height: "25px", fontSize: "12px" }}
                            onClick={() => {
                              setEditDescription(true);
                            }}
                          >
                            <img
                              src={editDescription ? whitePen : ""}
                              className={editDescription ? "pe-1" : ""}
                              alt=""
                              width={16}
                            />
                            Edit
                          </button>

                          <button
                            className="descButton"
                            style={{ height: "25px", fontSize: "12px" }}
                            onClick={() => {
                              setEditDescription(false);
                              dispatch(
                                UpdateTaskDescription({
                                  taskid: props.taskid,
                                  taskdescription: draftToHtml(
                                    convertToRaw(
                                      editorState2.getCurrentContent(),
                                    ),
                                  ),
                                }),
                              );
                            }}
                          >
                            ✓ &nbsp; Save
                          </button>
                        </div>

                        {/* AddForm */}
                        <AddForm
                          setChangeComp={setChangeComp}
                          // taskId={props.taskid}
                          taskId={taskId}
                          setTaskId={props.setTaskid}
                          modalFunction={props.modalFunction}
                          project={project}
                          setProject={setProject}
                          // childData={handleDataFromChild}
                          // translation1={fetchAddTask[2]?.translation}
                          // translation2={fetchAddTask[11]?.translation}
                          // translation3={fetchAddTask[17]?.translation}
                          // translation4={fetchAddTask[41]?.translation}
                        />

                        {/* Checklist */}
                        <Checklist
                          translation1={t("Checklist")}
                          translation2={t("Add a checklist...")}
                          fetchAddTask={fetchAddTask}
                          setShowAddItem={setShowAddItem}
                          showAddItem={showAddItem}
                          inputRef={inputRef}
                          checklist={checklist}
                          percent={percent}
                          updateChecklist={updateChecklist}
                          setChecklist={setChecklist}
                          setTotalCheck={setTotalCheck}
                          deleteChecklist={deleteChecklist}
                          inputRef2={inputRef2}
                          checklistTitle={checklistTitle}
                          handleAddChecklist={handleAddChecklist}
                          setChecklistTitle={setChecklistTitle}
                          setChangeComp={setChangeComp}
                          rowClickRef={rowClickRef}
                        />

                        {/* TaskProductsPart */}
                        <TaskProductsPart
                          setChangeComp={setChangeComp}
                          taskId={props.taskid}
                          projectId={project?.projectid}
                          setTaskId={props.setTaskid}
                          modalFunction={props.modalFunction}
                          // attachmentsFetchData={attachmentsFetchData}
                          childData={handleDataFromChild}
                          // addedEquipments={addedEquipments}
                          activityStyle={{
                            minWidth: "100px",
                          }}
                          actiTable={{
                            maxWidth: "1000px",
                            overflow: "auto",
                          }}
                          // translation1={fetchAddTask[126]?.translation}
                          // translation2={fetchAddTask[127]?.translation}
                          // translation3={fetchAddTask[128]?.translation}
                          // translation4={fetchAddTask[129]?.translation}
                          // translation5={fetchAddTask[130]?.translation}
                          // translation6={fetchAddTask[131]?.translation}
                        />

                        {/* Activity */}
                        <Activity
                          setChangeComp={setChangeComp}
                          taskId={props.taskid}
                          projectId={project?.projectid}
                          setTaskId={props.setTaskid}
                          modalFunction={props.modalFunction}
                          // attachmentsFetchData={attachmentsFetchData}
                          childData={handleDataFromChild}
                          // addedEquipments={addedEquipments}
                          activityStyle={{
                            minWidth: "100px",
                          }}
                          actiTable={{
                            maxWidth: "1000px",
                            overflow: "auto",
                          }}
                          // translation1={fetchAddTask[126]?.translation}
                          // translation2={fetchAddTask[127]?.translation}
                          // translation3={fetchAddTask[128]?.translation}
                          // translation4={fetchAddTask[129]?.translation}
                          // translation5={fetchAddTask[130]?.translation}
                          // translation6={fetchAddTask[131]?.translation}
                        />

                        {/* comment */}
                        <div
                          className="task-modal-dependencies-new-box"
                          style={{ marginTop: "2rem" }}
                        >
                          <div className="task-modal-dependencies-box-1 frcb">
                            <p className="mb-0">{t("Comments")}</p>
                            {props?.length > 1 ? (
                              <p
                                className="mb-0"
                                onClick={() => {
                                  props.setEnableComm(!props.enablecomm);
                                  props.setShowcmnt(!props.showcmnt);
                                  setShowMoreComm(!showMoreComm);
                                }}
                              >
                                {props.enablecomm
                                  ? `${t("Show less")}`
                                  : `${t("Show more...")}`}{" "}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            // paddingBottom: "35px",
                            // paddingLeft: "30px",
                            // paddingRight: "30px",

                            paddingLeft: "14px",
                            paddingRight: "14px",
                          }}
                          className={
                            props.modalFunction === "add"
                              ? "row commentarea pointerNone"
                              : "row commentarea"
                          }
                        >
                          <div className="px-0 my-1 col-1 d-flex">
                            <button
                              className="teambtn comment-abbre-pop"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              style={{
                                marginTop: "10px",
                                textTransform: "uppercase",
                                fontSize: "clamp(16px, .833vw, .833vw)",
                                width: " clamp(37px, 1.927vw, 1.927vw)",
                                height: "clamp(37px, 1.927vw, 1.927vw)",
                                borderRadius: "50%",
                                border: "none",
                              }}
                            >
                              {userlastname
                                ? userfirstname[0]?.toUpperCase() +
                                  "" +
                                  userlastname[0]?.toUpperCase()
                                : userfirstname.slice(0, 2).toUpperCase()}
                            </button>
                          </div>
                          <div
                            className="ps-2 col-11"
                            id="addTaskComntBox"
                            style={{ height: "150px" }}
                          >
                            <Editor
                              placeholder={t("Write a comment")}
                              editorState={editorState}
                              onEditorStateChange={changeApplied}
                              wrapperClassName="wrapper-class ms-1"
                              editorClassName="task-comment-text-pop text-black"
                              wrapperStyle={{ width: "105%" }}
                              editorStyle={{ width: "105%" }}
                              toolbarClassName="toolbar-bottom-absolute"
                              toolbarHidden={true}
                              mention={{
                                separator: " ",
                                trigger: "@",
                                suggestions: activeuser.map((x) => ({
                                  text: `${x.firstname} ${x.lastname}`,
                                  value: `${x.firstname} ${x.lastname}`,
                                  url: x.userid,
                                })),
                              }}
                            />
                            {showDropPeopleComm && (
                              <div
                                className="drop-down-plus-pop at_the_rate"
                                id="drop-down-plus"
                              >
                                <div className="search-div-people">
                                  <FiSearch
                                    style={{
                                      marginRight: "6px",
                                      marginBottom: "3px",
                                    }}
                                  />
                                  <input
                                    type="text"
                                    style={
                                      searchPeople
                                        ? {
                                            opacity: "100%",
                                          }
                                        : {
                                            opacity: "50%",
                                          }
                                    }
                                    className="search-people-input"
                                    placeholder={t("search")}
                                    value={searchPeople}
                                    onChange={(e) => {
                                      setChangeComp(e.target.value);
                                      setSearchPeople(e.target.value);
                                    }}
                                  />
                                </div>

                                {activeuser?.map((people, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="peoples-flex"
                                      onClick={() => {
                                        selectedUser(people);
                                      }}
                                    >
                                      <p
                                        style={{
                                          marginBottom: "0",
                                        }}
                                      >
                                        {people?.firstname} {people?.lastname}
                                      </p>
                                    </div>
                                  );
                                })}
                              </div>
                            )}

                            <div
                              role={"button"}
                              className=" position-relative"
                              style={{
                                left: "79%",
                                bottom: "25%",
                              }}
                            >
                              <p>
                                <span
                                  className="ms-xxl-2"
                                  style={{
                                    display: "grid",
                                    alignItems: "center",
                                    gridTemplateColumns: "1fr 1fr 16fr",
                                    position: "relative",
                                    bottom: "1px",
                                    right: "2px",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      marginRight: "5px",
                                    }}
                                  >
                                    <img
                                      alt="emoji"
                                      src={Icon2}
                                      style={{
                                        cursor: "pointer",
                                        width: "15px",
                                        marginBottom: "3px",
                                      }}
                                      onClick={() =>
                                        setShowEmojiPicker(!showEmojiPicker)
                                      }
                                    />
                                    {showEmojiPicker && (
                                      <div
                                        ref={emojiPickerRef}
                                        className="emoji-picker-style"
                                        style={{
                                          left: "-256px",
                                        }}
                                      >
                                        <Picker
                                          data={data}
                                          onEmojiSelect={(e) => {
                                            const contentState =
                                              Modifier.replaceText(
                                                editorState.getCurrentContent(),
                                                editorState.getSelection(),
                                                e.native,
                                                editorState.getCurrentInlineStyle(),
                                              );
                                            setEditorState(
                                              EditorState.push(
                                                editorState,
                                                contentState,
                                                "insert-characters",
                                              ),
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <DocumentUploaderWithProgress
                                    onUploaded={(data) => {
                                      setUploadedFileName(data[0].name);
                                      setChangeComp(data);
                                      setAttachmentUrl(data?.[0]?.link);
                                      props.handleFileChange(data);
                                    }}
                                  >
                                    <label>
                                      <i
                                        className="bi bi-paperclip attach-icon-pop"
                                        style={{
                                          color: "#bfbfbf",
                                          marginTop: "3px",
                                        }}
                                      ></i>
                                    </label>
                                  </DocumentUploaderWithProgress>

                                  <img
                                    style={{
                                      marginBottom: "1px",
                                      width: "15px",
                                      opacity: "50%",
                                    }}
                                    src={send}
                                    className="me-5"
                                    alt="leftarrow"
                                    onClick={() => {
                                      if (
                                        props.val.length > 132 || props.imgUrl
                                          ? "arrowEvent"
                                          : ""
                                      ) {
                                        let trimText = props.val.trim();
                                        if (trimText !== "") {
                                          if (
                                            props.modalFunction === "update"
                                          ) {
                                            props.handleAddComments();
                                            setEditorState(() =>
                                              EditorState.createEmpty(),
                                            );
                                          } else {
                                            let attachments = props.imgUrl;
                                            let message = props.val;
                                            let timestamp =
                                              new Date().toISOString();
                                            props.setShow([
                                              ...props.show,
                                              {
                                                attachments,
                                                message,
                                                timestamp,
                                                taggedUser: props.taggedUser,
                                              },
                                            ]);
                                            props.setLength(props.show.length);
                                            props.setMaxComments([
                                              ...props.maxComments,
                                              {
                                                attachments,
                                                message,
                                                timestamp,
                                                taggedUser: props.taggedUser,
                                              },
                                            ]);
                                            props.setTaggedUser([]);
                                            props.setMessage("");
                                            props.setVal("");
                                            props.setImgUrl("");
                                            setEditorState(() =>
                                              EditorState.createEmpty(),
                                            );
                                          }
                                        }
                                      }
                                      setUploadedFileName("");
                                      setAttachmentUrl("");
                                    }}
                                  />
                                </span>
                              </p>
                            </div>
                          </div>
                          {isImage && (
                            <div className="uploadFileUrl">
                              <img src={attachmentUrl} alt="" />
                            </div>
                          )}
                          <div className="col-11 uploadedFileName ps-3">
                            {/* {uploadedFileName} */}
                            {uploadedFileName?.length > 20
                              ? uploadedFileName?.slice(0, 20) + "..."
                              : uploadedFileName}
                          </div>
                        </div>

                        <div>
                          {props.maxComments
                            ?.slice(0, displayQuantity)
                            .map((item, index) => (
                              <div
                                key={index}
                                className="px"
                                style={{
                                  marginTop: "1rem",
                                  marginBottom: "1rem",
                                  display: "flex",
                                  paddingLeft: "3px",
                                  paddingRight: "17px",
                                }}
                              >
                                <div className="px-0 my-1 col-1 d-flex">
                                  <button
                                    className="teambtn"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    style={{
                                      textTransform: "uppercase",
                                      fontSize: "clamp(16px, .833vw, .833vw)",
                                      width: "clamp(37px, 1.927vw, 1.927vw)",
                                      height: "clamp(37px, 1.927vw, 1.927vw)",
                                      borderRadius: "50%",
                                      border: "none",
                                    }}
                                  >
                                    {item?.lastname
                                      ? item?.firstname[0]?.toUpperCase() +
                                        "" +
                                        item?.lastname[0]?.toUpperCase()
                                      : item?.firstname
                                          ?.slice(0, 2)
                                          .toUpperCase()}
                                  </button>
                                </div>
                                <div
                                  className="col-11 comment-box ps-2"
                                  style={{
                                    borderRadius: "10px",
                                    border: "1px rgb(133, 133, 133) solid",
                                    marginLeft: "12px",
                                  }}
                                >
                                  <div className="row">
                                    {/* First section (takes 3 rows) */}
                                    <div
                                      className="col-12 fntMessage text-start position-relative"
                                      style={{
                                        gridRow: "span 2", // Spans 2 rows in CSS Grid
                                      }}
                                    >
                                      <span
                                        id="comment_attach"
                                        style={{
                                          fontSize:
                                            "clamp(14px, .729vw, .729vw)",
                                          color: "#333333",
                                        }}
                                      >
                                        {item.isdeleted ? (
                                          <span>This message was deleted</span>
                                        ) : isJson(item.message) ? (
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: getFormattedMessage(
                                                item.message,
                                              ),
                                            }}
                                          ></span>
                                        ) : (
                                          item.message
                                        )}
                                        &nbsp;
                                        {!item?.isdeleted &&
                                          item?.attachments && (
                                            <a
                                              href={item.attachments}
                                              target="_blank"
                                              className="image-link"
                                              rel="noreferrer"
                                            >
                                              <span className="fw-bold taskclr text-break">
                                                {/* {item.attachments.split(".com/")[1]} */}

                                                {JSON.parse(
                                                  item?.attachments,
                                                )[0]
                                                  ?.split("/")
                                                  .pop()}

                                                {/* {item.attachments?.split("/").pop()} */}
                                              </span>
                                            </a>
                                          )}
                                      </span>
                                    </div>

                                    {/* Second section (takes 1 row) */}
                                    <div
                                      className="col-12 text-end dateTime fntdate"
                                      style={{
                                        display: "flex",
                                        gap: "5px",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        gridRow: "span 1", // Spans 1 row in CSS Grid
                                      }}
                                    >
                                      <div
                                        className="row"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-end",
                                          fontSize:
                                            "clamp(14px, .729vw, .729vw)",
                                          paddingRight: "15px", // Adds 5px padding from the right
                                        }}
                                      >
                                        {!item?.isdeleted && (
                                          <>
                                            {/* {moment(item.timestamp).format(
                                              "DD.MM.YYYY, h:mm a",
                                            )} */}

                                            {formatDateTime(item.timestamp)}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>

                        <hr class="dotted-separator"></hr>

                        {/* time tracked */}
                        <div class="time-recorded-card">
                          <div class="header ms-0">
                            <span class="icon">
                              <img src={timerIcon} alt="Timer Icon" />
                            </span>
                            <span class="title">Time Recorded</span>
                          </div>
                          <div class="content">
                            <div class="time-entry">
                              <span class="time">
                                {totalHours}:{totalMinutes} hrs
                              </span>
                              <span class="description-task">
                                Today, {dayName}
                              </span>
                            </div>
                            <div class="time-entry">
                              <span class="time">
                                {totalHours}:{totalMinutes} hrs
                              </span>
                              <span class="description-task">Total</span>
                            </div>
                          </div>
                        </div>

                        <hr class="dotted-separator"></hr>

                        <div class="section position-relative">
                          <div
                            className="d-flex px-"
                            style={{
                              color: "#333333",
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "bold",
                              justifyContent: "space-between",
                            }}
                          >
                            <p
                              className={
                                beginningTab ? "beginTabON" : "beginTabOFF"
                              }
                              onClick={() => {
                                setBeginningTab(true);
                              }}
                            >
                              Beginning <br /> of Work
                            </p>
                            <p
                              className={
                                !beginningTab ? "beginTabON" : "beginTabOFF"
                              }
                              onClick={() => {
                                setBeginningTab(false);
                              }}
                            >
                              End and Proof <br /> of Work
                            </p>
                          </div>
                          <div class="box" style={{ background: "lightgray" }}>
                            {/* for multiple imgs show👇 */}
                            {/* {proofOfWorkData.length > 0 ? (
                          proofOfWorkData?.map((item, index) => {
                            if (index === 0) {
                              return (
                                <div>
                                  <img
                                    src={item?.url}
                                    alt=""
                                    style={{
                                      width: "290px",
                                      height: "145px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              );
                            }
                          })
                        ) */}
                            {/* for single img show👇 */}
                            {workProofImgLink.length > 0 && beginningTab ? (
                              <div className="d-flex align-items-center">
                                <button
                                  // disabled={currentIndex === 0}
                                  onClick={handlePrev}
                                  style={{
                                    width: "auto",
                                    height: "max-content",
                                  }}
                                >
                                  <img
                                    src={LeftArrow}
                                    alt=""
                                    style={{ transform: "rotate(180deg)" }}
                                  />
                                </button>

                                <img
                                  src={workProofImgLink[currentIndex]}
                                  alt=""
                                  style={{
                                    width: "175px",
                                    height: "145px",
                                    objectFit: "contain",
                                  }}
                                />

                                <button
                                  //disabled={currentIndex === workProofImgLink.length - 1}
                                  onClick={handleNext}
                                  style={{
                                    width: "auto",
                                    height: "max-content",
                                  }}
                                >
                                  <img src={LeftArrow} alt="" />
                                </button>
                              </div>
                            ) : workProofImgLink2.length > 0 &&
                              !beginningTab ? (
                              <div className="d-flex align-items-center">
                                <button
                                  onClick={handlePrev2}
                                  style={{
                                    width: "auto",
                                    height: "max-content",
                                  }}
                                >
                                  <img
                                    src={LeftArrow}
                                    alt=""
                                    style={{ transform: "rotate(180deg)" }}
                                  />
                                </button>

                                <img
                                  src={workProofImgLink2[currentIndex2]}
                                  alt=""
                                  style={{
                                    width: "175px",
                                    height: "145px",
                                    objectFit: "contain",
                                  }}
                                />

                                <button
                                  onClick={handleNext2}
                                  style={{
                                    width: "auto",
                                    height: "max-content",
                                  }}
                                >
                                  <img src={LeftArrow} alt="" />
                                </button>
                              </div>
                            ) : (
                              // <DocumentUploaderWithProgress
                              //   onUploaded={(data) => {
                              //     setWorkProofImgLink(data[0].link);
                              //     setChangeComp(data);
                              //     props.handleFileChange(data);
                              //     dispatch(UpdateTaskImage(taskId, data[0].link));
                              //   }}
                              // >
                              //   <img src={photoIcon} alt="Camera Icon" />
                              //   <button style={{ display: "flex" }}>
                              //     <span> Take a photo</span>
                              //   </button>
                              // </DocumentUploaderWithProgress>

                              <div
                                onClick={() => {
                                  setOpenCameraPopup(!openCameraPopup);
                                }}
                              >
                                <img src={photoIcon} alt="Camera Icon" />
                                <button style={{ display: "flex" }}>
                                  <span> Take a photo</span>
                                </button>
                              </div>
                            )}
                          </div>

                          {openCameraPopup && (
                            <div className="openCameraDiv p-2 ps-4 mx-3">
                              <div class="text-end pointer">
                                <img
                                  src={XiconCircle}
                                  alt=""
                                  onClick={() => {
                                    setOpenCameraPopup(false);
                                  }}
                                />
                              </div>

                              <div
                                className="d-fle-x gap-3 align-items-center d-none"
                                onClick={() => {
                                  setCameraOpen(true);
                                }}
                              >
                                <img src={cameraicon} alt="" width={50} />
                                Open your Camera
                              </div>
                              {/* <br /> */}
                              <DocumentUploaderWithProgress
                                onUploaded={(data) => {
                                  // beginningTab
                                  //   ? setWorkProofImgLink(data[0].link)
                                  //   : setWorkProofImgLink2(data[0].link);
                                  beginningTab
                                    ? setWorkProofImgLink((prev) => [
                                        ...prev,
                                        data[0].link, // for single.
                                        // ...data.map((x) => x.link), // for multi.
                                      ])
                                    : setWorkProofImgLink2((prev) => [
                                        ...prev,
                                        data[0].link, // for single.
                                        // ...data.map((x) => x.link), // for multi.
                                      ]);
                                  setProofOfWorkData(data);
                                  setChangeComp(data);
                                  setMultiDocs(data);
                                  props.handleFileChange(data);
                                  // dispatch(UpdateTaskImage(taskId, data[0].link));

                                  let payload = data.map((item) => ({
                                    documentname: item.name,
                                    link: item.link,
                                    isStarted: beginningTab ? 1 : 2,
                                  }));

                                  dispatch(AdddocumenttoTask(taskId, payload));
                                }}
                              >
                                <div
                                  className="d-flex gap-3 align-items-center pb-4"
                                  onClick={() => {
                                    // asc
                                  }}
                                >
                                  <img src={foldericon} alt="" width={50} />
                                  {/* <span> Upload from your system</span> */}
                                  <span>Upload (Camera / Gallery)</span>
                                </div>
                              </DocumentUploaderWithProgress>
                            </div>
                          )}

                          <div
                            // className={
                            //   workProofImgLink === ""
                            //     ? "text-end pointerEvents opacity-25"
                            //     : "text-end pointer"
                            // }
                            className={
                              beginningTab && workProofImgLink === ""
                                ? "text-end pointerEvents opacity-25"
                                : !beginningTab && workProofImgLink2 === ""
                                  ? "text-end pointerEvents opacity-25"
                                  : "text-end pointer d-flex"
                            }
                          >
                            <p
                              className="mb-0 ms-auto pt-2 px-2 fw-bold"
                              style={{ color: "#00246a" }}
                              onClick={() => {
                                setOpenCameraPopup(!openCameraPopup);
                              }}
                            >
                              Upload
                            </p>
                            <img
                              className="mt-1 me-3 pointerEvents opacity-25 d-none"
                              src={bin}
                              alt=""
                              // onClick={() => {
                              //   if (workProofImgLink === "") return;
                              //   // dispatch(UpdateTaskImage(taskId, ""));
                              //   // dispatch(DeleteDocs(item.documentId));
                              //   setWorkProofImgLink("");
                              // }}
                              onClick={() => {
                                if (beginningTab) {
                                  setWorkProofImgLink("");
                                } else {
                                  setWorkProofImgLink2("");
                                }
                              }}
                            />
                          </div>
                        </div>

                        <hr class="dotted-separator"></hr>

                        <div class="section">
                          <h3
                            style={{
                              color: "#333333",
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "bold",
                            }}
                          >
                            Client Signature
                          </h3>
                          <div class="box signature p-0 h-auto mb-auto">
                            {/* asc signature start */}
                            <div className="position-relative">
                              {!quote?.isSigned && (
                                <>
                                  {clientSignature ? (
                                    <img
                                      src={clientSignature}
                                      width={330}
                                      height={95}
                                      alt=""
                                    />
                                  ) : (
                                    <ReactSignatureCanvas
                                      ref={signRef}
                                      backgroundColor="#d7d7d74a"
                                      onEnd={onSignEnd}
                                      canvasProps={{
                                        width: quote?.isSigned ? 0 : 330,
                                        height: quote?.isSigned ? 0 : 95,
                                        id: "quote-signature-canvas",
                                      }}
                                    />
                                  )}
                                  <div
                                    className="signature-clear-button"
                                    style={{
                                      top: "5px",
                                      left: "unset",
                                      right: "10px",
                                    }}
                                    onClick={clearCanvas}
                                  >
                                    Clear
                                  </div>
                                  <div className="signature-pen-button d-none">
                                    <TfiPencilAlt2
                                      color="#7E7E7E"
                                      size={18}
                                      fill="#7E7E7E"
                                      onClick={() => handleDraw()}
                                    />
                                  </div>
                                  <div
                                    className="signature-eraser-button d-none"
                                    onClick={handleUseEraser}
                                  >
                                    <RiEraserFill color="#7E7E7E" size={18} />
                                  </div>
                                </>
                              )}
                              {quote?.isSigned && (
                                <img
                                  alt=""
                                  src={quote.signature}
                                  height={330}
                                  width={95}
                                  className="signature-image"
                                />
                              )}
                              <div
                                className="signature-horizontal-line"
                                style={{ bottom: "15px" }}
                              ></div>
                            </div>
                            {/* asc signature end */}
                          </div>
                        </div>

                        <div class="section">
                          <h3
                            style={{
                              color: "#333333",
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "bold",
                            }}
                          >
                            Executant Signature
                          </h3>
                          <div class="box signature p-0 h-auto mb-auto">
                            {/* asc signature start */}
                            <div className="position-relative">
                              {!quote?.isSigned && (
                                <>
                                  {executantSignature ? (
                                    <img
                                      src={executantSignature}
                                      width={330}
                                      height={95}
                                      alt=""
                                    />
                                  ) : (
                                    <ReactSignatureCanvas
                                      ref={signRef2}
                                      backgroundColor="#d7d7d74a"
                                      onEnd={onSignEnd2}
                                      canvasProps={{
                                        width: quote?.isSigned ? 0 : 330,
                                        height: quote?.isSigned ? 0 : 95,
                                        id: "quote-signature-canvas",
                                      }}
                                    />
                                  )}
                                  <div
                                    className="signature-clear-button"
                                    style={{
                                      top: "5px",
                                      left: "unset",
                                      right: "10px",
                                    }}
                                    onClick={clearCanvas2}
                                  >
                                    Clear
                                  </div>
                                  <div className="signature-pen-button d-none">
                                    <TfiPencilAlt2
                                      color="#7E7E7E"
                                      size={18}
                                      fill="#7E7E7E"
                                      onClick={() => handleDraw()}
                                    />
                                  </div>
                                  <div
                                    className="signature-eraser-button d-none"
                                    onClick={handleUseEraser}
                                  >
                                    <RiEraserFill color="#7E7E7E" size={18} />
                                  </div>
                                </>
                              )}
                              {quote?.isSigned && (
                                <img
                                  alt=""
                                  src={quote.signature}
                                  height={330}
                                  width={95}
                                  className="signature-image"
                                />
                              )}
                              <div
                                className="signature-horizontal-line"
                                style={{ bottom: "15px" }}
                              ></div>
                            </div>
                            {/* asc signature end */}
                          </div>
                        </div>

                        <hr class="dotted-separator"></hr>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Navigation */}
              <div className="navigation-footer d-none">
                <div className="navigation-footer-content">
                  <button
                    className="navigation-button navigation-button-cancel"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className="navigation-button navigation-button-navigate"
                    onClick={handleNavigate}
                  >
                    Navigate to Task Location
                  </button>
                  <button
                    className="navigation-button navigation-button-track"
                    onClick={handleTrackTask}
                  >
                    Start Tracking This Task
                  </button>
                </div>
              </div>

              {/* cancel and save button in bottom */}
              <div className="d-flex justify-content-between px-4 pb-5">
                <button
                  className="cancelBtn"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="addBtn"
                  onClick={(e) => {
                    handleFunction();
                  }}
                >
                  Save
                </button>
              </div>

              <MvpNewTrack
                childData={handleDataFromChild}
                pdfLoading={pdfLoading}
              />

              {dataFromChild && ( // when its true popup will open.
                <Modal
                  {...props}
                  id="asc_project"
                  dialogClassName="custum_projectPop"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Modal heading
          </Modal.Title>
        </Modal.Header> */}
                  <Modal.Body>
                    <div className="completeDivpop p-3 text-center">
                      <img src={checkedButton2} alt="" />
                      <p className="fw-bold">Task Completed</p>
                      <p className="">
                        The task was moved to status Completed and is removed
                        from your ToDo tasks.
                      </p>

                      <div className="d-flex justify-content-between">
                        <button
                          className="cancelBtn"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="addBtn"
                          onClick={(e) => {
                            // handleCheckboxChange(e);
                            ChangeStatus(
                              process.env.REACT_APP_TASK_STATUS_COMPLETE,
                            );
                            setTimeout(() => {
                              // history.goBack(); // move to filesInsertDocToS3Res.
                            }, 500);
                          }}
                        >
                          {runFunctionFromParent ? "Please wait..." : "Confirm"}
                          {/* Confirm */}
                        </button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              )}
              {isModalOpen && (
                <>
                  <div
                    className="blurred-background"
                    onClick={closeModal}
                  ></div>
                  <div className="modal-mvpnew">
                    <div className="mvp-modal-content">
                      <button className="close-btn" onClick={closeModal}>
                        &times;
                      </button>
                      <p className="modal-text">What would you like to do?</p>
                      <button className="navigation-btn">
                        <img
                          src={navigationIcon}
                          alt="icon"
                          className="button-icon"
                        />
                        Start Navigating
                      </button>
                      <button className="action-btn" onClick={closeModal}>
                        <img
                          src={clipboard}
                          alt="icon"
                          className="button-icon"
                        />
                        See Task details...
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          <div className="d-none ps-5">
            <CertificatePDF
              runFunctionFromParent={runFunctionFromParent}
              setRunFunctionFromParent={setRunFunctionFromParent}
              setPdfLoading={setPdfLoading}
            />
          </div>
        </>
      )}
    </>
  );
};

export default MvpNewAddTask;
